import Row from '.';
import RowDesignTool from "./RowDesignTool";
import { RowPropPanel } from "../../../../lib/builtin/components/Row/RowPropPanel";
import { ColConfigPanel } from "../../../../lib/builtin/components/Row/ColConfigPanel";
const makeEmptyRows = count => Array.from({
  length: count
}, () => ({
  type: 'w-col',
  children: [],
  props: {}
}));
const TWO_ROW_ICON = 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-row_1636423237344.png';

/** @type {UICore.ComponentMeta} */
const RowComponentMeta = {
  id: 'w-row',
  name: '分列容器',
  keywords: ['分列容器'],
  category: '布局',
  component: Row,
  slots: [{
    id: 'default',
    frozen: true,
    allowDeleteChildren: true
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'heightConfig',
      type: 'string',
      title: '容器高度',
      enum: [{
        value: 'default',
        label: '适应内容'
      }, {
        value: 'fillAvailable',
        label: '撑满容器(只兼容chrome)'
      }, {
        value: 'fixed',
        label: '固定高度'
      }]
    }, {
      id: 'height',
      type: 'string',
      title: '高度',
      default: '100px',
      condition: 'props.heightConfig==="fixed"'
    }, {
      id: 'gap',
      type: 'string',
      title: '列间距',
      enum: [{
        value: 'default',
        label: '默认'
      }, {
        value: 'compact',
        label: '紧凑'
      }, {
        value: 'none',
        label: '无间隔'
      }, {
        value: 'custom',
        label: '自定义'
      }]
    }, {
      id: 'gapCustom',
      type: 'string',
      title: '自定义列间距',
      default: '16px',
      condition: 'props.gap==="custom"'
    }, {
      id: 'className',
      type: 'string',
      hidden: true
    }, {
      id: 'css',
      type: 'string',
      title: '自定义CSS',
      ui: {
        settings: {
          multipleLine: true
        }
      },
      hidden: true
    }, {
      id: 'colConfig',
      type: 'string',
      title: '列比例',
      description: '例如  比例宽度:固定宽度:比例宽度  1 : 200px : 2',
      ui: {
        type: 'ColConfigPanel'
      },
      'uc:allowExpr': false,
      'uc:allowReset': false
    }, {
      id: 'preset',
      type: 'string',
      title: '预设选择',
      ui: {
        type: 'RowPropPanel'
      },
      'uc:allowExpr': false,
      'uc:allowReset': false
    }]
  },
  propPanel: {
    RowPropPanel: {
      component: RowPropPanel
    },
    ColConfigPanel: {
      component: ColConfigPanel
    }
  },
  inlineStyleProps: ['+gap', '+flex-grow'],
  presets: [{
    name: '两列',
    icon: TWO_ROW_ICON,
    layout: {
      children: makeEmptyRows(2)
    }
    // presets onApply的演示
    // onApply(event) {
    //   const layout = event.designer.activeComp;
    //   console.log('两列 onApply', layout);
    // },
  }, {
    name: '三列',
    icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-row-three_1636364985204.png',
    layout: {
      children: makeEmptyRows(3)
    }
  }],
  initialLayout: {
    props: {
      heightConfig: 'default'
    }
  },
  designerFlags: {
    allowAdjustHeight: false
  },
  designTool: RowDesignTool,
  getActions({
    layout,
    replaceCompWith
  }) {
    return [{
      title: '拆除分列',
      icon: 'fa fa-scissors',
      desc: '拆除分列组件，保留各列内容',
      execute: () => replaceCompWith(...[].concat(...layout.children.map(x => x.children || [])))
    }];
  },
  placeCompInside() {
    const getLayout = content => {
      const layoutContainer = {
        type: this.id,
        children: makeEmptyRows(2)
      };
      layoutContainer.children[0].children = content;
      return layoutContainer;
    };
    return {
      name: this.name,
      /** 组件图标 */
      icon: TWO_ROW_ICON,
      getLayout
    };
  }
};
export default RowComponentMeta;
//# sourceMappingURL=meta.js.map
